/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import {
  Signer,
  utils,
  BigNumberish,
  Contract,
  ContractFactory,
  Overrides,
} from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import type { Converter, ConverterInterface } from "../Converter";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "controller",
        type: "address",
      },
      {
        internalType: "address",
        name: "lba",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "_astoMultiplier",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_lpMultiplier",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "lbaEnergyStartTime",
        type: "uint256",
      },
      {
        internalType: "uint256",
        name: "_lbaEnergyFinishTime",
        type: "uint256",
      },
    ],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "errMsg",
        type: "string",
      },
    ],
    name: "AccessDenied",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "errMsg",
        type: "string",
      },
    ],
    name: "ContractError",
    type: "error",
  },
  {
    inputs: [
      {
        internalType: "string",
        name: "errMsg",
        type: "string",
      },
    ],
    name: "InvalidInput",
    type: "error",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "addr",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "EnergyUsed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "addr",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "LBAEnergyUsed",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Paused",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "previousAdminRole",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "bytes32",
        name: "newAdminRole",
        type: "bytes32",
      },
    ],
    name: "RoleAdminChanged",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleGranted",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        indexed: true,
        internalType: "address",
        name: "account",
        type: "address",
      },
      {
        indexed: true,
        internalType: "address",
        name: "sender",
        type: "address",
      },
    ],
    name: "RoleRevoked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "string",
        name: "tokenName",
        type: "string",
      },
      {
        indexed: true,
        internalType: "address",
        name: "staker",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "timestamp",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "Staked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "string",
        name: "tokenName",
        type: "string",
      },
      {
        indexed: true,
        internalType: "address",
        name: "staker",
        type: "address",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "timestamp",
        type: "uint256",
      },
      {
        indexed: false,
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "UnStaked",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: false,
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "Unpaused",
    type: "event",
  },
  {
    inputs: [],
    name: "ASTO_TOKEN_ID",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "DEFAULT_ADMIN_ROLE",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "LP_TOKEN_ID",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address",
      },
    ],
    name: "addConsumer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address",
      },
    ],
    name: "addManager",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "astoMultiplier",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address",
      },
    ],
    name: "calculateAstoEnergy",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address",
      },
    ],
    name: "calculateAvailableLBAEnergy",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address",
      },
    ],
    name: "calculateEnergy",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address",
      },
    ],
    name: "calculateLpEnergy",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "currentTime",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "energyStorage_",
    outputs: [
      {
        internalType: "contract EnergyStorage",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address",
      },
    ],
    name: "getConsumedEnergy",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address",
      },
    ],
    name: "getConsumedLBAEnergy",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address",
      },
    ],
    name: "getDailyASTOEnergyProduction",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address",
      },
    ],
    name: "getDailyLBAEnergyProduction",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address",
      },
    ],
    name: "getDailyLPEnergyProduction",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address",
      },
    ],
    name: "getEnergy",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "getLBAEnergyStartTime",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address",
      },
    ],
    name: "getRemainingLBAEnergy",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleAdmin",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "uint256",
        name: "index",
        type: "uint256",
      },
    ],
    name: "getRoleMember",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
    ],
    name: "getRoleMemberCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "grantRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "hasRole",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "dao",
        type: "address",
      },
      {
        internalType: "address",
        name: "multisig",
        type: "address",
      },
      {
        internalType: "address",
        name: "energyStorage",
        type: "address",
      },
      {
        internalType: "address",
        name: "lbaEnergyStorage",
        type: "address",
      },
      {
        internalType: "address",
        name: "stakingLogic",
        type: "address",
      },
    ],
    name: "init",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "isLBAEnergyFinished",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "lbaEnergyFinishTime",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "lbaEnergyStorage_",
    outputs: [
      {
        internalType: "contract EnergyStorage",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "lba_",
    outputs: [
      {
        internalType: "contract ILiquidityBootstrapAuction",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "lpMultiplier",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "pause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "paused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address",
      },
    ],
    name: "removeConsumer",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address",
      },
    ],
    name: "removeManager",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "renounceRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "role",
        type: "bytes32",
      },
      {
        internalType: "address",
        name: "account",
        type: "address",
      },
    ],
    name: "revokeRole",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_astoMultiplier",
        type: "uint256",
      },
    ],
    name: "setASTOMultiplier",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newController",
        type: "address",
      },
    ],
    name: "setController",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newDao",
        type: "address",
      },
    ],
    name: "setDao",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "finishTime",
        type: "uint256",
      },
    ],
    name: "setLBAEnergyFinishTime",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_lpMultiplier",
        type: "uint256",
      },
    ],
    name: "setLPMultiplier",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newMultisig",
        type: "address",
      },
      {
        internalType: "address",
        name: "dao",
        type: "address",
      },
    ],
    name: "setMultisig",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newContract",
        type: "address",
      },
    ],
    name: "setStakingLogic",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "stakingLogic_",
    outputs: [
      {
        internalType: "contract Staking",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "bytes4",
        name: "interfaceId",
        type: "bytes4",
      },
    ],
    name: "supportsInterface",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "unpause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "addr",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256",
      },
    ],
    name: "useEnergy",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

const _bytecode =
  "0x60806040526002805461ff00191690553480156200001c57600080fd5b5060405162002a4b38038062002a4b8339810160408190526200003f916200037c565b6002805460ff191690556001600160a01b0386163b620000a557604080518082018252601281527124b73b30b634b21021b7b73a3937b63632b960711b6020820152905163dcfb398d60e01b81526200009c9190600401620003d9565b60405180910390fd5b6001600160a01b0385163b620000f157604080518082018252600b81526a496e76616c6964204c424160a81b6020820152905163dcfb398d60e01b81526200009c9190600401620003d9565b600380546001600160a01b0319166001600160a01b038716179055620001387f7b765e0e932d348852a6f810bfa1ab891e259123f02db8cdcde614c5702233578762000162565b600884905560098390556006829055600781905562000156620001a5565b50505050505062000429565b6200017982826200020260201b620019411760201c565b6000828152600160209081526040909120620001a0918390620019c5620002a3821b17901c565b505050565b620001af620002c3565b6002805460ff191660011790557f62e78cea01bee320cd4e420270b5ea74000d11b0c9f74754ebdbfc544b05a258620001e53390565b6040516001600160a01b03909116815260200160405180910390a1565b6000828152602081815260408083206001600160a01b038516845290915290205460ff166200029f576000828152602081815260408083206001600160a01b03851684529091529020805460ff191660011790556200025e3390565b6001600160a01b0316816001600160a01b0316837f2f8788117e7eff1d82e926ec794901d17c78024a50270940304540a733656f0d60405160405180910390a45b5050565b6000620002ba836001600160a01b0384166200030d565b90505b92915050565b60025460ff16156200030b5760405162461bcd60e51b815260206004820152601060248201526f14185d5cd8589b194e881c185d5cd95960821b60448201526064016200009c565b565b60008181526001830160205260408120546200035657508154600181810184556000848152602080822090930184905584548482528286019093526040902091909155620002bd565b506000620002bd565b80516001600160a01b03811681146200037757600080fd5b919050565b60008060008060008060c087890312156200039657600080fd5b620003a1876200035f565b9550620003b1602088016200035f565b945060408701519350606087015192506080870151915060a087015190509295509295509295565b600060208083528351808285015260005b818110156200040857858101830151858201604001528201620003ea565b506000604082860101526040601f19601f8301168501019250505092915050565b61261280620004396000396000f3fe608060405234801561001057600080fd5b50600436106102a05760003560e01c8063927ee01011610167578063c71f8966116100ce578063d547741f11610087578063d547741f14610599578063d888313b146105ac578063d8affe87146105bf578063d9d3a9b4146105d2578063fc2ccaa5146105da578063fefb3f53146105ed57600080fd5b8063c71f89661461053e578063c77f310814610551578063ca15c8731461055a578063cf81427b1461056d578063d18e81b314610580578063d437ec991461058657600080fd5b8063a86086b911610120578063a86086b9146104e1578063a93e9767146104ea578063ac18de43146104fd578063acf7903414610510578063b452290014610523578063b697a73a1461053657600080fd5b8063927ee0101461048d57806392eefe9b146104a05780639fef2704146104b3578063a133dd06146104bb578063a217fddf146104b3578063a32dac7b146104ce57600080fd5b8063386fa5a91161020b5780636637b882116101c45780636637b88214610426578063832aed52146104395780638456cb591461044c5780638fc0f5eb146104545780639010d07c1461046757806391d148541461047a57600080fd5b8063386fa5a9146103b35780633f4ba83a146103e45780635444bcda146103ec5780635ab4f21e146103ff5780635c975abb146104125780636560b8f11461041d57600080fd5b8063248a9ca31161025d578063248a9ca31461033c5780632d06177a1461035f5780632f2ff15d14610372578063314a566b14610385578063359ef75b1461038d57806336568abe146103a057600080fd5b806301ffc9a7146102a55780630549a7a2146102cd5780630c9d9097146102ee5780630e27e3df14610301578063112940f914610316578063182ec69d14610329575b600080fd5b6102b86102b33660046120e4565b610600565b60405190151581526020015b60405180910390f35b6102e06102db366004612125565b61062b565b6040519081526020016102c4565b6102e06102fc366004612125565b6106f5565b61031461030f366004612125565b61076c565b005b610314610324366004612125565b610839565b610314610337366004612140565b6108fb565b6102e061034a36600461216a565b60009081526020819052604090206001015490565b61031461036d366004612125565b610b5d565b610314610380366004612183565b610c0d565b6102e0610c37565b61031461039b3660046121af565b610cc5565b6103146103ae366004612183565b610eb1565b6002546103cc906201000090046001600160a01b031681565b6040516001600160a01b0390911681526020016102c4565b610314610f2b565b6103146103fa366004612125565b610f4e565b6102e061040d366004612125565b610f91565b60025460ff166102b8565b6102e060085481565b610314610434366004612125565b610fdc565b610314610447366004612214565b611047565b6103146110a6565b6102e0610462366004612125565b6110c6565b6103cc61047536600461223e565b6111de565b6102b8610488366004612183565b6111f6565b6102e061049b366004612125565b61121f565b6103146104ae366004612125565b611352565b6102e0600081565b6103146104c936600461216a565b611399565b6102e06104dc366004612125565b6113b7565b6102e060095481565b6004546103cc906001600160a01b031681565b61031461050b366004612125565b6113dc565b6102e061051e366004612125565b61148c565b6102e0610531366004612125565b61157c565b6102b86115fb565b6102e061054c366004612125565b61160d565b6102e060075481565b6102e061056836600461216a565b6116d2565b61031461057b36600461216a565b6116e9565b426102e0565b6003546103cc906001600160a01b031681565b6103146105a7366004612183565b611707565b6102e06105ba366004612125565b61172c565b6005546103cc906001600160a01b031681565b6102e0600181565b6103146105e836600461216a565b611834565b6102e06105fb366004612125565b611852565b60006001600160e01b03198216635a05180f60e01b14806106255750610625826119da565b92915050565b6000816001600160a01b03811661067f57604080518082018252601e81526000805160206125bd8339815191526020820152905163d647364f60e01b81526106769190600401612284565b60405180910390fd5b6005546040516325594acf60e21b81526001600160a01b038581166004830152909116906395652b3c906024015b602060405180830381865afa1580156106ca573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906106ee91906122b7565b9392505050565b600080610700610c37565b9050804210156107135750600092915050565b600060075461071f4290565b1061072c5760075461072e565b425b9050600061073c83836122e6565b905060006107498661160d565b90506107626201518061075c8484611a0f565b90611a1b565b9695505050505050565b6040805180820190915260008051602061257d833981519152815260008051602061255d83398151915260208201526107ad8160005b6020020151336111f6565b1580156107c257506107c08160016107a2565b155b1561080b5760408051808201825260158152744d697373696e6720726571756972656420726f6c6560581b60208201529051633e9486cb60e21b81526106769190600401612284565b6108357f9d56108290ea0bc9c5c59c3ad357dca9d1b29ed7f3ae1443bef2fa2159bdf5e883611a27565b5050565b6040805180820190915260008051602061257d833981519152815260008051602061255d83398151915260208201526108738160006107a2565b15801561088857506108868160016107a2565b155b156108d15760408051808201825260158152744d697373696e6720726571756972656420726f6c6560581b60208201529051633e9486cb60e21b81526106769190600401612284565b6108357f9d56108290ea0bc9c5c59c3ad357dca9d1b29ed7f3ae1443bef2fa2159bdf5e883611a49565b610903611a6b565b7f9d56108290ea0bc9c5c59c3ad357dca9d1b29ed7f3ae1443bef2fa2159bdf5e861092d81611ab3565b826001600160a01b03811661097657604080518082018252601e81526000805160206125bd8339815191526020820152905163d647364f60e01b81526106769190600401612284565b61097f846110c6565b8311156109cb57604080518082018252601681527515dc9bdb99c81bdc881b5a5cdcd95908185b5bdd5b9d60521b6020820152905163d647364f60e01b81526106769190600401612284565b60006109d685610f91565b905060006109e48583611abd565b90508015610a9557600554604051625ab5dd60e31b81526001600160a01b03888116600483015260248201849052909116906302d5aee890604401600060405180830381600087803b158015610a3957600080fd5b505af1158015610a4d573d6000803e3d6000fd5b50505050856001600160a01b03167f519582bc3c9209f77c9e9e71c0778e4975ddebb2483733dd13eabfa01dee30bb82604051610a8c91815260200190565b60405180910390a25b6000610aa182876122e6565b90508015610b545760048054604051625ab5dd60e31b81526001600160a01b038a811693820193909352602481018490529116906302d5aee890604401600060405180830381600087803b158015610af857600080fd5b505af1158015610b0c573d6000803e3d6000fd5b50505050866001600160a01b03167f9d73ed34dacbac5cdf56e41f23697b9468c9696dcc7bef392a8077129616bba282604051610b4b91815260200190565b60405180910390a25b50505050505050565b6040805180820190915260008051602061257d833981519152815260008051602061255d8339815191526020820152610b978160006107a2565b158015610bac5750610baa8160016107a2565b155b15610bf55760408051808201825260158152744d697373696e6720726571756972656420726f6c6560581b60208201529051633e9486cb60e21b81526106769190600401612284565b61083560008051602061259d83398151915283611a49565b600082815260208190526040902060010154610c2881611ab3565b610c328383611a49565b505050565b60008060065411610cbe57600360009054906101000a90046001600160a01b03166001600160a01b031663847e27086040518163ffffffff1660e01b8152600401602060405180830381865afa158015610c95573d6000803e3d6000fd5b505050506040513d601f19601f82011682018060405250810190610cb991906122b7565b905090565b5060065490565b60008051602061257d833981519152610cdd81611ab3565b600254610100900460ff16610ea9576001600160a01b0384163b610d40576040805180820182526016815275496e76616c696420456e657267792053746f7261676560501b6020820152905163dcfb398d60e01b81526106769190600401612284565b6001600160a01b0383163b610d9b57604080518082018252601a81527f496e76616c6964204c424120456e657267792053746f726167650000000000006020820152905163dcfb398d60e01b81526106769190600401612284565b6001600160a01b0382163b610dee576040805180820182526015815274496e76616c6964205374616b696e67204c6f67696360581b6020820152905163dcfb398d60e01b81526106769190600401612284565b600280546001600160a01b03808516620100000262010000600160b01b031990921691909117909155600480548683166001600160a01b0319918216179091556005805492861692909116919091179055610e697f3b5d4cc60d3ec3516ee8ae083bd60934f6eb2a6c54b1229985c41bfb092b260387611a49565b610e8160008051602061255d83398151915286611a49565b610e9960008051602061259d83398151915286611a49565b6002805461ff0019166101001790555b505050505050565b6001600160a01b0381163314610f215760405162461bcd60e51b815260206004820152602f60248201527f416363657373436f6e74726f6c3a2063616e206f6e6c792072656e6f756e636560448201526e103937b632b9903337b91039b2b63360891b6064820152608401610676565b6108358282611a27565b60008051602061257d833981519152610f4381611ab3565b610f4b611ad3565b50565b60008051602061259d833981519152610f6681611ab3565b50600280546001600160a01b03909216620100000262010000600160b01b0319909216919091179055565b600080610f9d836106f5565b90506000610faa8461062b565b9050600082118015610fbb57508082115b15610fd257610fca81836122e6565b949350505050565b5060009392505050565b60008051602061257d833981519152610ff481611ab3565b61101d7f3b5d4cc60d3ec3516ee8ae083bd60934f6eb2a6c54b1229985c41bfb092b2603611b25565b6108357f3b5d4cc60d3ec3516ee8ae083bd60934f6eb2a6c54b1229985c41bfb092b260383611a49565b60008051602061257d83398151915261105f81611ab3565b61107660008051602061255d833981519152611b25565b61108e60008051602061255d83398151915284611a49565b610c3260008051602061255d83398151915283611a49565b60008051602061257d8339815191526110be81611ab3565b610f4b611b64565b600254604051635d5d6ef160e01b81526001600160a01b0383811660048301526000926201000090041690635d5d6ef190602401602060405180830381865afa158015611117573d6000803e3d6000fd5b505050506040513d601f19601f8201168201806040525081019061113b919061230f565b1561119057600061114b836113b7565b905060006111588461062b565b6111618561157c565b61116b9190612331565b9050600081831161117d576000611187565b61118782846122e6565b95945050505050565b600061119b836113b7565b905060006111a88461157c565b905060008183116111ba5760006111c4565b6111c482846122e6565b90506111cf85610f91565b6111879082612331565b919050565b60008281526001602052604081206106ee9083611ba1565b6000918252602082815260408084206001600160a01b0393909316845291905290205460ff1690565b6000816001600160a01b03811661126a57604080518082018252601e81526000805160206125bd8339815191526020820152905163d647364f60e01b81526106769190600401612284565b6002546000906201000090046001600160a01b031663688011df600186426040516001600160e01b031960e086901b16815260048101939093526001600160a01b0390911660248301526044820152606401600060405180830381865afa1580156112d9573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f1916820160405261130191908101906123b4565b90506000815111611313576000610fca565b610fca600954826001845161132891906122e6565b81518110611338576113386122f9565b602002602001015160200151611a0f90919063ffffffff16565b60008051602061257d83398151915261136a81611ab3565b61138160008051602061257d833981519152611b25565b61083560008051602061257d83398151915283611a49565b60008051602061259d8339815191526113b181611ab3565b50600755565b6000806113c383611852565b905060006113d08461148c565b9050610fca8183612331565b6040805180820190915260008051602061257d833981519152815260008051602061255d83398151915260208201526114168160006107a2565b15801561142b57506114298160016107a2565b155b156114745760408051808201825260158152744d697373696e6720726571756972656420726f6c6560581b60208201529051633e9486cb60e21b81526106769190600401612284565b61083560008051602061259d83398151915283611a27565b6000816001600160a01b0381166114d757604080518082018252601e81526000805160206125bd8339815191526020820152905163d647364f60e01b81526106769190600401612284565b6002546000906201000090046001600160a01b031663688011df600186426040516001600160e01b031960e086901b16815260048101939093526001600160a01b0390911660248301526044820152606401600060405180830381865afa158015611546573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f1916820160405261156e91908101906123b4565b9050610fca81600954611bad565b6000816001600160a01b0381166115c757604080518082018252601e81526000805160206125bd8339815191526020820152905163d647364f60e01b81526106769190600401612284565b600480546040516325594acf60e21b81526001600160a01b03868116938201939093529116906395652b3c906024016106ad565b60006007546116074290565b11905090565b6000816001600160a01b03811661165857604080518082018252601e81526000805160206125bd8339815191526020820152905163d647364f60e01b81526106769190600401612284565b600954600354604051638384a39560e01b81526001600160a01b0386811660048301526106ee93921690638384a39590602401602060405180830381865afa1580156116a8573d6000803e3d6000fd5b505050506040513d601f19601f820116820180604052508101906116cc91906122b7565b90611a0f565b600081815260016020526040812061062590611c93565b60008051602061259d83398151915261170181611ab3565b50600855565b60008281526020819052604090206001015461172281611ab3565b610c328383611a27565b6000816001600160a01b03811661177757604080518082018252601e81526000805160206125bd8339815191526020820152905163d647364f60e01b81526106769190600401612284565b6002546000906201000090046001600160a01b031663688011df8286426040516001600160e01b031960e086901b16815260048101939093526001600160a01b0390911660248301526044820152606401600060405180830381865afa1580156117e5573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f1916820160405261180d91908101906123b4565b9050600081511161181f576000610fca565b610fca600854826001845161132891906122e6565b60008051602061259d83398151915261184c81611ab3565b50600955565b6000816001600160a01b03811661189d57604080518082018252601e81526000805160206125bd8339815191526020820152905163d647364f60e01b81526106769190600401612284565b6002546000906201000090046001600160a01b031663688011df8286426040516001600160e01b031960e086901b16815260048101939093526001600160a01b0390911660248301526044820152606401600060405180830381865afa15801561190b573d6000803e3d6000fd5b505050506040513d6000823e601f3d908101601f1916820160405261193391908101906123b4565b9050610fca81600854611bad565b61194b82826111f6565b610835576000828152602081815260408083206001600160a01b03851684529091529020805460ff191660011790556119813390565b6001600160a01b0316816001600160a01b0316837f2f8788117e7eff1d82e926ec794901d17c78024a50270940304540a733656f0d60405160405180910390a45050565b60006106ee836001600160a01b038416611c9d565b60006001600160e01b03198216637965db0b60e01b148061062557506301ffc9a760e01b6001600160e01b0319831614610625565b60006106ee8284612481565b60006106ee8284612498565b611a318282611cec565b6000828152600160205260409020610c329082611d51565b611a538282611941565b6000828152600160205260409020610c3290826119c5565b60025460ff1615611ab15760405162461bcd60e51b815260206004820152601060248201526f14185d5cd8589b194e881c185d5cd95960821b6044820152606401610676565b565b610f4b8133611d66565b6000818310611acc57816106ee565b5090919050565b611adb611dca565b6002805460ff191690557f5db9ee0a495bf2e6ff9c91a7834c1ba4fdd244a5e8aa4e537bd38aeae4b073aa335b6040516001600160a01b03909116815260200160405180910390a1565b6000611b30826116d2565b9050805b8015610c3257611b5283611b4d816104756001866122e6565b611a27565b80611b5c816124ba565b915050611b34565b611b6c611a6b565b6002805460ff191660011790557f62e78cea01bee320cd4e420270b5ea74000d11b0c9f74754ebdbfc544b05a258611b083390565b60006106ee8383611e13565b8151600090819042905b8015611c8557600086611bcb6001846122e6565b81518110611bdb57611bdb6122f9565b602002602001015190508060000151831015611bf75750611c75565b86518214600081611c3b57611c3683600001518a8681518110611c1c57611c1c6122f9565b602002602001015160000151611e3d90919063ffffffff16565b611c48565b8251611c48908690611e3d565b9050611c6f611c68896116cc866020015185611a0f90919063ffffffff16565b8790611e49565b95505050505b611c7e816124ba565b9050611bb7565b506111878262015180611a1b565b6000610625825490565b6000818152600183016020526040812054611ce457508154600181810184556000848152602080822090930184905584548482528286019093526040902091909155610625565b506000610625565b611cf682826111f6565b15610835576000828152602081815260408083206001600160a01b0385168085529252808320805460ff1916905551339285917ff6391f5c32d9c69d2a47ea670b442974b53935d1edc7fd64eb21e047a839171b9190a45050565b60006106ee836001600160a01b038416611e55565b611d7082826111f6565b61083557611d88816001600160a01b03166014611f48565b611d93836020611f48565b604051602001611da49291906124d1565b60408051601f198184030181529082905262461bcd60e51b825261067691600401612284565b60025460ff16611ab15760405162461bcd60e51b815260206004820152601460248201527314185d5cd8589b194e881b9bdd081c185d5cd95960621b6044820152606401610676565b6000826000018281548110611e2a57611e2a6122f9565b9060005260206000200154905092915050565b60006106ee82846122e6565b60006106ee8284612331565b60008181526001830160205260408120548015611f3e576000611e796001836122e6565b8554909150600090611e8d906001906122e6565b9050818114611ef2576000866000018281548110611ead57611ead6122f9565b9060005260206000200154905080876000018481548110611ed057611ed06122f9565b6000918252602080832090910192909255918252600188019052604090208390555b8554869080611f0357611f03612546565b600190038181906000526020600020016000905590558560010160008681526020019081526020016000206000905560019350505050610625565b6000915050610625565b60606000611f57836002612481565b611f62906002612331565b67ffffffffffffffff811115611f7a57611f7a612344565b6040519080825280601f01601f191660200182016040528015611fa4576020820181803683370190505b509050600360fc1b81600081518110611fbf57611fbf6122f9565b60200101906001600160f81b031916908160001a905350600f60fb1b81600181518110611fee57611fee6122f9565b60200101906001600160f81b031916908160001a9053506000612012846002612481565b61201d906001612331565b90505b6001811115612095576f181899199a1a9b1b9c1cb0b131b232b360811b85600f1660108110612051576120516122f9565b1a60f81b828281518110612067576120676122f9565b60200101906001600160f81b031916908160001a90535060049490941c9361208e816124ba565b9050612020565b5083156106ee5760405162461bcd60e51b815260206004820181905260248201527f537472696e67733a20686578206c656e67746820696e73756666696369656e746044820152606401610676565b6000602082840312156120f657600080fd5b81356001600160e01b0319811681146106ee57600080fd5b80356001600160a01b03811681146111d957600080fd5b60006020828403121561213757600080fd5b6106ee8261210e565b6000806040838503121561215357600080fd5b61215c8361210e565b946020939093013593505050565b60006020828403121561217c57600080fd5b5035919050565b6000806040838503121561219657600080fd5b823591506121a66020840161210e565b90509250929050565b600080600080600060a086880312156121c757600080fd5b6121d08661210e565b94506121de6020870161210e565b93506121ec6040870161210e565b92506121fa6060870161210e565b91506122086080870161210e565b90509295509295909350565b6000806040838503121561222757600080fd5b6122308361210e565b91506121a66020840161210e565b6000806040838503121561225157600080fd5b50508035926020909101359150565b60005b8381101561227b578181015183820152602001612263565b50506000910152565b60208152600082518060208401526122a3816040850160208701612260565b601f01601f19169190910160400192915050565b6000602082840312156122c957600080fd5b5051919050565b634e487b7160e01b600052601160045260246000fd5b81810381811115610625576106256122d0565b634e487b7160e01b600052603260045260246000fd5b60006020828403121561232157600080fd5b815180151581146106ee57600080fd5b80820180821115610625576106256122d0565b634e487b7160e01b600052604160045260246000fd5b6040805190810167ffffffffffffffff8111828210171561237d5761237d612344565b60405290565b604051601f8201601f1916810167ffffffffffffffff811182821017156123ac576123ac612344565b604052919050565b600060208083850312156123c757600080fd5b825167ffffffffffffffff808211156123df57600080fd5b818501915085601f8301126123f357600080fd5b81518181111561240557612405612344565b612413848260051b01612383565b818152848101925060069190911b83018401908782111561243357600080fd5b928401925b8184101561247657604084890312156124515760008081fd5b61245961235a565b845181528585015186820152835260409093019291840191612438565b979650505050505050565b8082028115828204841417610625576106256122d0565b6000826124b557634e487b7160e01b600052601260045260246000fd5b500490565b6000816124c9576124c96122d0565b506000190190565b7f416363657373436f6e74726f6c3a206163636f756e7420000000000000000000815260008351612509816017850160208801612260565b7001034b99036b4b9b9b4b733903937b6329607d1b601791840191820152835161253a816028840160208801612260565b01602801949350505050565b634e487b7160e01b600052603160045260246000fdfea5a0b70b385ff7611cd3840916bd08b10829e5bf9e6637cf79dd9a427fc0e2ab7b765e0e932d348852a6f810bfa1ab891e259123f02db8cdcde614c570223357241ecf16d79d0f8dbfb92cbc07fe17840425976cf0667f022fe9877caa831b0857726f6e67206f72206d69737365642077616c6c657420616464726573730000a2646970667358221220d82a9f8327b2937762315ca80a0f539e889684709d49fb06b6eb70e2c967bcd764736f6c63430008110033";

export class Converter__factory extends ContractFactory {
  constructor(
    ...args: [signer: Signer] | ConstructorParameters<typeof ContractFactory>
  ) {
    if (args.length === 1) {
      super(_abi, _bytecode, args[0]);
    } else {
      super(...args);
    }
  }

  deploy(
    controller: string,
    lba: string,
    _astoMultiplier: BigNumberish,
    _lpMultiplier: BigNumberish,
    lbaEnergyStartTime: BigNumberish,
    _lbaEnergyFinishTime: BigNumberish,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): Promise<Converter> {
    return super.deploy(
      controller,
      lba,
      _astoMultiplier,
      _lpMultiplier,
      lbaEnergyStartTime,
      _lbaEnergyFinishTime,
      overrides || {}
    ) as Promise<Converter>;
  }
  getDeployTransaction(
    controller: string,
    lba: string,
    _astoMultiplier: BigNumberish,
    _lpMultiplier: BigNumberish,
    lbaEnergyStartTime: BigNumberish,
    _lbaEnergyFinishTime: BigNumberish,
    overrides?: Overrides & { from?: string | Promise<string> }
  ): TransactionRequest {
    return super.getDeployTransaction(
      controller,
      lba,
      _astoMultiplier,
      _lpMultiplier,
      lbaEnergyStartTime,
      _lbaEnergyFinishTime,
      overrides || {}
    );
  }
  attach(address: string): Converter {
    return super.attach(address) as Converter;
  }
  connect(signer: Signer): Converter__factory {
    return super.connect(signer) as Converter__factory;
  }
  static readonly bytecode = _bytecode;
  static readonly abi = _abi;
  static createInterface(): ConverterInterface {
    return new utils.Interface(_abi) as ConverterInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): Converter {
    return new Contract(address, _abi, signerOrProvider) as Converter;
  }
}
